import React, { useMemo, useState } from 'react';
import { VerseChip } from '../ui/VerseChip';

type LangKey = 'en' | 'fr' | 'ee';

export interface TaleDetail {
  id: string;
  title: string;
  verse_ref: string | null;
  content: Record<LangKey, { title?: string; narrative?: string; summary?: string }>;
}

const LANG_LABEL: Record<LangKey, string> = { en: 'English', fr: 'Français', ee: 'Eʋegbe' };

export default function TaleStoryPanel({ tale }: { tale: TaleDetail }) {
  const langs = useMemo<LangKey[]>(
    () => (['en','fr','ee'] as LangKey[]).filter(l => tale.content?.[l]?.narrative),
    [tale]
  );
  const [active, setActive] = useState<LangKey>(langs[0] ?? 'en');

  const activeContent = tale.content?.[active];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3">
                            <div className="text-sm text-muted-foreground">
                      {tale.verse_ref ? (
                        <VerseChip refText={tale.verse_ref} />
                      ) : (
                        <span className="opacity-60">No verse selected</span>
                      )}
                    </div>

        <div className="flex gap-2">
          {(['en','fr','ee'] as LangKey[]).map(l => (
            <button
              key={l}
              onClick={() => setActive(l)}
              className={
                'px-3 py-1.5 rounded-md text-sm ' +
                (active === l
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted hover:bg-muted/80')
              }
              disabled={!tale.content?.[l]?.narrative}
              title={LANG_LABEL[l]}
            >
              {LANG_LABEL[l]}
            </button>
          ))}
        </div>
      </div>

      <div className="rounded-lg border bg-card">
        <div className="p-4 border-b">
          <div className="text-lg font-semibold">
            {activeContent?.title || tale.title}
          </div>
          {activeContent?.summary && (
            <div className="mt-1 text-sm text-muted-foreground">{activeContent.summary}</div>
          )}
        </div>
        <div className="p-4 leading-7 whitespace-pre-wrap">
          {activeContent?.narrative || (
            <span className="opacity-60">No narrative for {LANG_LABEL[active]}.</span>
          )}
        </div>
      </div>
    </div>
  );
}
